import React, { useState, useRef, useEffect } from 'react';
import { 
  Box, 
  TextField, 
  IconButton, 
  Fade, 
  Typography,
  Grow,
  Paper,
  InputBase
} from '@mui/material';
import { keyframes } from '@mui/system';
import SendIcon from '@mui/icons-material/SendRounded';
import CloseIcon from '@mui/icons-material/Close';
import FusionAIIcon from '../../Media/FusionAI.png';

//icons
const icons = {
      ThumbsUp: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.4" d="M16.4578 4.19055C16.7016 2.9718 15.9094 1.78586 14.6906 1.54211C13.4719 1.29836 12.2859 2.09055 12.0422 3.3093L11.9344 3.84367C11.625 5.39992 10.7719 6.7968 9.53437 7.79055L9.1875 8.06711C8.11875 8.92023 7.5 10.214 7.5 11.5827V12.7499V14.9999V16.7952C7.5 18.2999 8.25 19.7062 9.50156 20.5405L11.3062 21.7452C12.0469 22.2374 12.9141 22.4999 13.8047 22.4999H18.375C19.6172 22.4999 20.625 21.4921 20.625 20.2499C20.625 20.0812 20.6062 19.9218 20.5734 19.7624C21.4734 19.4671 22.125 18.6234 22.125 17.6249C22.125 17.1984 22.0078 16.7999 21.8016 16.4577C22.8422 16.2609 23.625 15.3468 23.625 14.2499C23.625 13.5421 23.2969 12.9093 22.7859 12.4968C23.5078 12.1218 24 11.3671 24 10.4999C24 9.25773 22.9922 8.24992 21.75 8.24992H15C15.6422 7.16711 16.1016 5.97648 16.35 4.72492L16.4578 4.19055Z" fill="#1C9045"/>
        <path d="M0 10.5C0 9.67031 0.670312 9 1.5 9H4.5C5.32969 9 6 9.67031 6 10.5V21C6 21.8297 5.32969 22.5 4.5 22.5H1.5C0.670312 22.5 0 21.8297 0 21V10.5Z" fill="#1C9045"/>
        </svg>                
      ),

        ThumbsDown: (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.4" d="M16.4578 19.8094C16.7016 21.0281 15.9094 22.2141 14.6906 22.4578C13.4719 22.7016 12.2859 21.9094 12.0422 20.6906L11.9344 20.1562C11.625 18.6 10.7719 17.2031 9.53437 16.2094L9.1875 15.9328C8.11875 15.0797 7.5 13.7859 7.5 12.4172V11.25V9V7.20469C7.5 5.7 8.25 4.29375 9.50156 3.45938L11.3062 2.25469C12.0516 1.7625 12.9187 1.5 13.8047 1.5H18.375C19.6172 1.5 20.625 2.50781 20.625 3.75C20.625 3.91875 20.6062 4.07812 20.5734 4.2375C21.4734 4.52813 22.125 5.37656 22.125 6.375C22.125 6.80156 22.0078 7.2 21.8016 7.54219C22.8422 7.73906 23.625 8.65312 23.625 9.75C23.625 10.4578 23.2969 11.0906 22.7859 11.5031C23.5078 11.8781 24 12.6328 24 13.5C24 14.7422 22.9922 15.75 21.75 15.75H15C15.6422 16.8328 16.1016 18.0234 16.35 19.275L16.4578 19.8094Z" fill="#000D1F" fill-opacity="0.6"/>
            <path d="M0 16.5C0 17.3297 0.670312 18 1.5 18H4.5C5.32969 18 6 17.3297 6 16.5V6C6 5.17031 5.32969 4.5 4.5 4.5H1.5C0.670312 4.5 0 5.17031 0 6V16.5Z" fill="#000D1F" fill-opacity="0.6"/>
            </svg> 
      ),
    };

// Background floating animation
const float = keyframes`
  0% { transform: translateY(3px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(3px); }
`;


// Cookie functions
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
};

const getCookie = (name) => {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let c = cookies[i].trim();
    if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
  }
  return null;
};

const ChatBox = ({ onClose,cookiesAllowed}) => {
  
  
  const [userMessage, setUserMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [mobileNumber, setMobileNumber] = useState('');
  const [businessNumber, setBusinessNumber] = useState('');

  // State management
  const [messages, setMessages] = useState(() => {
    if (cookiesAllowed) {
      const storedMessages = getCookie('chatHistory');
      return storedMessages ? JSON.parse(storedMessages) : [{ type: 'server', text: 'Hi, I am Joy! How can i brighten your day?' }];
    }
    return [{ type: 'server', text: 'Hi, I am Joy! How can i brighten your day?' }];
  });
  
  // Refs
  const chatBoxRef = useRef(null);
  const inputRef = useRef(null);

    // Effects
    useEffect(() => {
        setBusinessNumber('+15876024694');
        setMobileNumber('+14034713552');
    }, []);
  
  // Handlers
  const handleUserMessageChange = (e) => setUserMessage(e.target.value);

  const handleSendMessage = async (message) => {
    if (!message.trim()) return;

    setMessages((prev) => [...prev, { type: 'user', text: message }]);
    setUserMessage('');
    setLoading(true);

    try {
        const requestBody = {
            message,
            number: mobileNumber,
            business_number: businessNumber,
        };

      const response = await fetch('https://fusionbot.vanguardfusion.ca/api8000/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      const serverReply = response.ok ? data.message : 'Error: Server response issue';
      
      setMessages((prev) => [...prev, { type: 'server', text: serverReply }]);
      await simulateTyping(serverReply);
    } catch {
      setMessages((prev) => [...prev, { type: 'server', text: 'Error: Connection failed' }]);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage(userMessage);
    }
  };

  // Simulate typing effect for server responses
  const simulateTyping = async (text) => {
    const delay = 10;
    for (let i = 0; i <= text.length; i++) {
      await new Promise((resolve) => setTimeout(resolve, delay));
      setMessages((prev) => [
        ...prev.slice(0, -1),
        { type: 'server', text: text.slice(0, i) }
      ]);
    }
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  };

  // Effects
  useEffect(() => {
    if (chatBoxRef.current) {
      chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
    }
  }, [messages]);

  useEffect(() => {
    if (cookiesAllowed) {
      setCookie('chatHistory', JSON.stringify(messages), 7);
    }
  }, [messages, cookiesAllowed]);
  
  
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      width: '100%',
      overflow: 'hidden',
      borderRadius: '20px',
      boxShadow: '0 5px 20px rgba(0,0,0,0.2)',
    }}>
      {/* Header */}
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 2,
        backgroundColor: '#007EA7',
        color: 'white',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <a
                href="https://www.vanguardfusion.ca/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Visit Vanguard Fusion website"
                style={{ textDecoration: 'none', color: 'inherit', display: 'flex', alignItems: 'center', gap: '16px' }}
            >
                <Box 
                component="img" 
                src={FusionAIIcon}
                sx={{ 
                    width: 40, 
                    height: 40, 
                    borderRadius: '50%',
                    background: 'white',
                    padding: '2px'
                }}
                />
                <Box>
                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    Fusion AI Chat Bot
                </Typography>
                <Typography variant="caption" sx={{ opacity: 0.9 }}>
                    24/7 AI agent to get instant support and aswers
                </Typography>
                </Box>
            </a>
        </Box>

        <IconButton onClick={onClose} sx={{ color: 'white' }}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Messages Container */}
      <Box 
        ref={chatBoxRef} 
        sx={{
          flex: 1,
          overflowY: 'auto',
          padding: 2,
          backgroundColor: '#f5f5f5'
        }}
      >
        {messages.map((message, index) => (
          <Box 
            key={index}
            sx={{
              display: 'flex',
              justifyContent: message.type === 'user' ? 'flex-end' : 'flex-start',
              mb: 2
            }}
          >
            {message.type === 'server' && (
              <Paper 
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: '18px',
                  backgroundColor: '#e9f5f8',
                  maxWidth: '80%'
                }}
              >
                <Typography variant="body1">
                  {message.text}
                </Typography>
              </Paper>
            )}
            
            {message.type === 'user' && (
              <Paper 
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: '18px',
                  backgroundColor: 'white',
                  maxWidth: '80%'
                }}
              >
                <Typography variant="body1">
                  {message.text}
                </Typography>
              </Paper>
            )}
          </Box>
        ))}

        {loading && (
          <Fade in>
            <Box sx={{ display: 'flex', justifyContent: 'center', padding: 3 }}>
              <Box sx={{
                background: 'rgb(220, 245, 252)',
                borderRadius: '24px',
                padding: 1.5,
                display: 'flex',
                gap: 0.5,
              }}>
                {[...Array(3)].map((_, i) => (
                  <Box key={i} sx={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    background: 'rgb(0, 77, 102)',
                    animation: `${float} 1.2s infinite`,
                    animationDelay: `${i * 0.2}s`
                  }} />
                ))}
              </Box>
            </Box>
          </Fade>
        )}


      </Box>

      {/* Footer */}
      <Box sx={{ 
        pb: 1, 
        borderTop: '1px solid rgba(0,0,0,0.1)',
        backgroundColor: '#F4F9FC'
      }}>
        {/* Input Area */}
        <Paper
          component="form"
          sx={{
            p: '2px 4px',
            display: 'flex',
            alignItems: 'center',
            border: '0px soft rgba(0, 0, 0, 0.12)',
            boxShadow:'none',
            borderRadius: '0px'
          }}
        >
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Type a message..."
            value={userMessage}
            onChange={handleUserMessageChange}
            onKeyDown={handleKeyDown}
            inputRef={inputRef}
          />
          <IconButton 
            sx={{ p: '10px', color: userMessage.trim() ? '#0085A1' : 'rgba(0, 0, 0, 0.26)' }}
            disabled={!userMessage.trim() || loading}
            onClick={() => handleSendMessage(userMessage)}
          >
            <SendIcon />
          </IconButton>
        </Paper>

        
        {/* Feedback Section */}
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'flex-end', 
          alignItems: 'center',
          mt: 1,
          px:2
        }}>
          
          <IconButton size="small" sx={{ color: '#4CAF50', mr: 1 }}>
          {icons.ThumbsUp}
          </IconButton>
          <IconButton size="small" sx={{ color: '#757575' }}>
          {icons.ThumbsDown}
          </IconButton>
          
          <Box sx={{ flex: 1 }} />
          
          <Typography variant="body2" sx={{ mr: 1, color: 'gray' }}>
            Powered by
          </Typography>
          <a href="https://www.vanguardfusion.ca/" target="_blank" rel="noopener noreferrer" aria-label="Visit Vanguard Fusion website Fusion AI" style={{ textDecoration: 'none', color: 'inherit' }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                Fusion.AI
            </Typography>
          </a>
        </Box>
        
        
      </Box>
    </Box>
  );
};

export default ChatBox;
